module.exports = __webpack_public_path__ + "img/ruble-sign.83638b53.svg";